<div class="modal-header bg-info">
    <h4 class="modal-title text-white">
        {{ customerName }}'s Statement
    </h4>
    <button
        type="button"
        class="pull-right close"
        data-dismiss="modal"
        aria-
        label="Close"
        (click)="emitClose()"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12 pt-0 pb-1 mb-0">
            <div class="client-modal card mt-0 pt-0 px-0 shadow-lg">
                <div class="card-body mt-0 pt-1 pb-2 mx-0 px-2">
                    <div class="iteration">
                        <div
                            class="item-container mt-1 pt-0"
                            *ngFor="
                            let item of data 
                            | paginate : {
                              itemsPerPage: pageSize,
                              currentPage: p,
                              totalItems: total
                            };
                            let i = index"
                        >
                            <div class="list-card card my-0 py-1 mx-auto px-0 shadow-lg">
                                <div class="list-card-body card-body my-0 py-0 mx-0">
                                    <div class="row my-0 py-0">
                                        <div class="col-12 my-0 py-0">
                                            <div class="row">
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 col-xl-7 d-flex justify-content-start">
                                                            <span class="">Txn Date</span>
                                                        </div>
                                                        <div
                                                            class="col-6 col-xl-5 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.dateTaken}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 col-xl-7 d-flex justify-content-start">
                                                            <span class="">Txn Time</span>
                                                        </div>
                                                        <div
                                                            class="col-6 col-xl-5 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.timeTaken}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 col-xl-7 d-flex justify-content-start">
                                                            <span class="">Txn Type</span>
                                                        </div>
                                                        <div
                                                            class="col-6 col-xl-5 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                Micro Loan
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 col-xl-7 d-flex justify-content-start">
                                                            <span class="">Principal Amount</span>
                                                        </div>
                                                        <div
                                                            class="col-6 col-xl-5 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.principalTaken | number}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 col-xl-7 d-flex justify-content-start">
                                                            <span class="">Interest Amount</span>
                                                        </div>
                                                        <div
                                                            class="col-6 col-xl-5 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.loanInterestTaken | number}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 d-flex justify-content-start">
                                                            <span class="">Interest Rate</span>
                                                        </div>
                                                        <div
                                                            class="col-6 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.microloanCustomerLoanInterest | number}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 d-flex justify-content-start">
                                                            <span class="">Principal Paid</span>
                                                        </div>
                                                        <div
                                                            class="col-6 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.principalPaid | number}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 d-flex justify-content-start">
                                                            <span class="">Int + Loan Paid</span>
                                                        </div>
                                                        <div
                                                            class="col-6 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.loanInterestPaid | number}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-6 col-xl-4">
                                                    <div class="row">
                                                        <div class="col-6 d-flex justify-content-start">
                                                            <span class="">Balance</span>
                                                        </div>
                                                        <div
                                                            class="col-6 d-flex justify-content-start font-weight-bold">
                                                            <span class="itemCreated">
                                                                {{item.theBalance | number}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        (click)="emitClose()"
        class="btn btn-info col-3 col-xl-2 pull-right"
        type="button"
    >
        close
    </button>
</div>
